<template>
    <div class="websiteSettings" v-if="permisShow('官网设置')">
        <div class="part">
            <div class="item">
                <div class="text">
                    公司中文名称
                    <i style="color:#F56C6C;padding-right:6px;">*</i>：
                </div>
                <el-input v-model="Form.enterpriseName" placeholder="请输入公司中文名称"></el-input>
            </div>
            <div class="item">
                <div class="text">公司英文名称：</div>
                <el-input v-model="Form.enterpriseEnglishName" placeholder="请输入公司英文名称"></el-input>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">联 系 电 话：</div>
                <el-input v-model="Form.contactsNumber" placeholder="请输入联系电话"></el-input>
            </div>
            <div class="item">
                <div class="text">联 系 人：</div>
                <el-input v-model="Form.contacts" placeholder="请输入联系人"></el-input>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">邮箱：</div>
                <el-input v-model="Form.mailbox" placeholder="请输入邮箱"></el-input>
            </div>
            <div class="item">
                <div class="text">联 系 地 址：</div>
                <el-input v-model="Form.contactsAddress" placeholder="请输入联系地址"></el-input>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">备 案 号：</div>
                <el-input v-model="Form.recordNumber" placeholder="请输入备案号"></el-input>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">
                    公司logo
                    <i style="color:#F56C6C;padding-right:6px;">*</i>：
                </div>
                <el-upload class="avatar-uploader" :before-upload="beforeUpload" :headers="headers"
                    :action="`${$uploadUrl}/erp/qiniu/uploadImg`" :show-file-list="false"
                    :on-success="handleAvatarSuccess">
                    <img v-if="Form.enterpriseLogo" :src="'http://'+Form.enterpriseLogo" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="tippx">建议尺寸：200*44像素</div>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">微信公众号：</div>
                <el-upload class="avatar-uploader" :before-upload="beforeUpload" :headers="headers"
                    :action="`${$uploadUrl}/erp/qiniu/uploadImg`" :show-file-list="false" :on-error="handleAvatarError"
                    :on-success="handleAvatarSuccess1">
                    <img v-if="Form.enterpriseWechat" :src="'http://'+Form.enterpriseWechat" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="tippx">建议尺寸：90*90像素</div>
            </div>
        </div>
        <div class="part">
            <div class="item">
                <div class="text">房源默认图片：</div>
                <el-upload class="avatar-uploader" :before-upload="beforeUpload" :headers="headers"
                    :action="`${$uploadUrl}/erp/qiniu/uploadImg`" :show-file-list="false" :on-error="handleAvatarError"
                    :on-success="handleAvatarSuccess2">
                    <img v-if="Form.housePicture" :src="'http://'+Form.housePicture" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <div class="tippx">建议尺寸：710*400像素</div>
            </div>
        </div>

        <el-button @click="save" type="primary" v-points>保存</el-button>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";
import { webSystem } from "@/api";
import { queryWebsiteCompany } from "@/api/systemSetup";
import { Loading } from "element-ui";
export default {
    data() {
        let token = sessionStorage.getItem("accessToken") || "";
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            headers: { accessToken: token },
            Form: {
                enterpriseName: "", //企业名称
                enterpriseLogo: "", //企业logo
                contacts: "", //联系人
                contactsNumber: "", //联系电话
                mailbox: "", //邮箱
                contactsAddress: "", //联系地址
                technicalSupport: "", //技术支持
                recordNumber: "", //备案号
                downloadApp: "", //下载ERP-APP
                enterpriseWechat: "", //企业微信公众号
                smsSignature: "", //短信签名
                enterpriseEnglishName: "", //公司英文名
                keyWords: "", //关键字
                describe: "", //描述
                weiName: "", //微站名称
                homePicture: "", //首页图标
                housePicture: "", //官网房源默认图片
                link: "", //微信配置链接
            },
        };
    },
    mounted() {
        this.queryWebsiteCompany();
    },

    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        beforeUpload(file){
            if (file.size / 1024 / 1024 > 8){}else {
                Loading.service({ background: 'transparent', text: '拼命上传中' });
            }
        },
        handleAvatarSuccess(file) {
            if (file.code == 200) {
                this.Form.enterpriseLogo = file.uri;
            } else {
                this.$message.error(file.msg);
            }
            Loading.service({ background: "transparent" }).close();
        },

        handleAvatarSuccess1(file) {
            if (file.code == 200) {
                this.Form.enterpriseWechat = file.uri;
            } else {
                this.$message.error(file.msg);
            }
            console.log(file);
            Loading.service({ background: "transparent" }).close();
        },
        handleAvatarSuccess2(file) {
            if (file.code == 200) {
                this.Form.housePicture = file.uri;
            } else {
                this.$message.error(file.msg);
            }
            Loading.service({ background: "transparent" }).close();
        },
        handleAvatarError(err, file, fileList) {
            console.log(err);
        },

        queryWebsiteCompany() {
            this.$post(queryWebsiteCompany).then((res) => {
                if (res.success) {
                    this.Form = res.data;
                }
            });
        },

        save() {
            if (!this.Form.enterpriseName) {
                this.$message.error("公司中文名称不能为空");
                return;
            }
            // if(!this.Form.enterpriseEnglishName){
            //     this.$message.error('公司英文名称不能为空')
            //     return
            // }
            if (!this.Form.enterpriseLogo) {
                this.$message.error("公司logo不能为空");
                return;
            }
            let reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
            ); //正则表达式
            if (this.Form.mailbox) {
                if (!reg.test(this.Form.mailbox)) {
                    this.$message.error("邮箱格式不正确");
                    return;
                }
            }
            let params = Object.assign({}, this.Form);
            if (params.remindEmployee) {
                delete params.remindEmployee;
            }
            if (params.remindEmployeeNames) {
                delete params.remindEmployeeNames;
            }
            this.$post(webSystem, params).then((res) => {
                if (res.success) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
    },
};
</script>

<style lang='less' >
.websiteSettings {
    padding: 30px;
    width: 100%;
    height: 100vh;
    background: #ffffff;
    .tippx{
        margin-left: 30px;
        color:#FF4700;
        font-size: 16px;
    }
    .el-button {
        background: #5e75e6;
        width: 160px;
        display: block;
        margin: 20px auto;
    }
    .part {
        display: flex;
        align-items: center;
        .item {
            .el-input .el-input__inner {
                width: 260px;
                height: 30px;
                background: #f5f5f5;
                border: none;
            }
            .text {
                min-width: 140px;
            }
            display: flex;
            align-items: center;
            padding: 10px 160px 10px 0;
        }
        .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409eff;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 120px;
            height: 90px;
            line-height: 90px;
            text-align: center;
        }
        .avatar {
            margin: 0;
            width: 120px;
            height: 90px;
            display: block;
        }
    }
}
</style>